import CardDoctor from "./CardDoctor";

export default CardDoctor;